import { useModal } from "./ModalContext";
import VideoHome from "./Modal/ModalHome";
import Search from "./Search";
import ModalAi from "./Modal/ModalAi";

const ModalContainer = () => {
  const { modalType, closeModal } = useModal();

  return (
    <>
      {modalType === "video-home" && <VideoHome onClose={closeModal} />}
      {modalType === "video-ai" && <ModalAi onClose={closeModal} />}
      {modalType === "search" && <Search onClose={closeModal} />}
    </>
  );
};

export default ModalContainer;